import {FaArrowLeft} from "react-icons/fa";
import {useLang} from "../context/LanguageContext";


export default function BackButton(props){
    const { t } = useLang();

    return (
        <button
            onClick={props.onClick}
            className="absolute top-5 left-5 px-4 py-2 bg-gray-300 rounded flex items-center space-x-2"
        >
            <FaArrowLeft/>
            <span>{t('btn.back')}</span>
        </button>
    )
}